import { render, staticRenderFns } from "./personnelDetail.vue?vue&type=template&id=5a1275b6&scoped=true&"
import script from "./personnelDetail.vue?vue&type=script&lang=js&"
export * from "./personnelDetail.vue?vue&type=script&lang=js&"
import style0 from "./personnelDetail.vue?vue&type=style&index=0&id=5a1275b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1275b6",
  null
  
)

export default component.exports